export const IntroMetrics = () => (
<div className="hero-metrics">            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 my-8 md:my-12 max-w-4xl mx-auto">
              <div className="bg-gradient-to-br from-red-900/40 to-red-950/40 p-4 md:p-6 rounded-xl border border-red-600/30 backdrop-blur-sm">
                <div data-testid="hero-results-timeframe" className="text-3xl md:text-5xl font-bold text-white mb-2">3–7j</div>
                <p className="text-gray-300 font-medium text-sm md:text-base">Résultats Visibles</p>
              </div>
              <div className="bg-gradient-to-br from-red-900/40 to-red-950/40 p-4 md:p-6 rounded-xl border border-red-600/30 backdrop-blur-sm">
                <div className="text-3xl md:text-5xl font-bold text-white mb-2">97%</div>
                <p className="text-gray-300 font-medium text-sm md:text-base">Taux de Réussite</p>
              </div>
              <div className="bg-gradient-to-br from-red-900/40 to-red-950/40 p-4 md:p-6 rounded-xl border border-red-600/30 backdrop-blur-sm">
                <div className="text-3xl md:text-5xl font-bold text-white mb-2">20+</div>
                <p className="text-gray-300 font-medium text-sm md:text-base">Ans d'Expérience</p>
              </div>
              <div className="bg-gradient-to-br from-red-900/40 to-red-950/40 p-4 md:p-6 rounded-xl border border-red-600/30 backdrop-blur-sm">
                <div data-testid="hero-satisfied-clients-count" className="text-3xl md:text-5xl font-bold text-white mb-2">280</div>
                <p className="text-gray-300 font-medium text-sm md:text-base">Clients Satisfaits</p>
              </div>
            </div>

</div>
);
